import React, { useEffect } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import GridTable from "../Common/GridTable";
import { useNavigate } from "react-router-dom";
import { ColDef, ValueFormatterParams } from "@material-ui/data-grid";
import { setResponseMessage } from "features/admin/adminSlice";
import { colors } from "@material-ui/core";
import { AiFillCloseCircle } from "react-icons/ai";
import { MdCheckCircle } from "react-icons/md";
import { CenteredTableRow } from "./columns/UpdatableCountField";
import {
  deletePromo,
  fetchAllPromos,
  selectAllPromos,
  selectLoading,
} from "features/admin/Promotion/promoAdminSlice";
import ClipboardField from "./columns/ClipboardField";
interface AllPromoTableProps {}
const columns: ColDef[] = [
  { sortable: false, field: "title", headerName: "Име", width: 400 },
  {
    field: "is_active",
    headerName: "Активен",
    width: 100,
    renderCell: (params: ValueFormatterParams) => (
      <CenteredTableRow>
        {params.value ? (
          <MdCheckCircle
            color={colors.green[500]}
            style={{ width: 32, height: 32 }}
          />
        ) : (
          <AiFillCloseCircle
            color={colors.red[500]}
            style={{ width: 32, height: 32 }}
          />
        )}
      </CenteredTableRow>
    ),
    align: "center",
  },
  {
    field: "url",
    headerName: "URL",
    width: 400,
    renderCell: (params: ValueFormatterParams) => (
      <ClipboardField value={params.value} />
    ),
    align: "center",
  },
];

const PromoTable: React.FC<AllPromoTableProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const promotions = useSelector(selectAllPromos);
  const isLoading = useSelector(selectLoading);
  useEffect(() => {
    dispatch(fetchAllPromos());
  }, [dispatch]);

  const add = () => {
    navigate("/promotions/add");
  };
  const refresh = () => {
    dispatch(fetchAllPromos());
  };
  const remove = (ids: string[]) => {
    ids.forEach((id: string) => {
      const _refId = promotions.find(
        (item: { id: number }) => item.id === parseInt(id)
      )?.refId;
      _refId &&
        batch(() => {
          dispatch(setResponseMessage({ message: "", hasError: false }));
          dispatch(deletePromo(_refId));
        });
    });
    dispatch(fetchAllPromos());
  };

  const edit = (id: string) => {
    const _refId = promotions.find(
      (item: { id: number }) => item.id === parseInt(id)
    )?.refId;
    _refId && navigate(`/promotions/edit/${_refId}`);
  };

  return (
    <GridTable
      add={add}
      refresh={refresh}
      remove={remove}
      edit={edit}
      data={promotions}
      columns={columns}
      isLoading={isLoading}
      searchProperty="title"
    />
  );
};

export default PromoTable;
